/* global angular */
'use strict'
import loaded from 'image-loaded'

export default
function (ngModule) {
  ngModule.directive('sourceAvatar', ['MediaTypeService', function (MediaTypeService) {
    return {
      restrict: 'E',
      template: require('./source-avatar.html'),
      controllerAs: 'vm',
      replace: true,
      scope: {
        mediaType: '=',
        title: '=',
        imageUrl: '=',
        linkUrl: '=',
        onClick: '=',
        width: '=',
        height: '=',
        disableImageScaling: '@'
      },
      controller: 'SourceAvatarController'
    }
  }])
  .controller('SourceAvatarController', ['$scope', 'MediaTypeService', 'UriService', 'APP_IMAGE_URL', SourceAvatarController])

  function SourceAvatarController ($scope, MediaTypeService, UriService, APP_IMAGE_URL) {
    this.height = $scope.height
    this.width = $scope.width
    this.title = $scope.title
    this.linkUrl = $scope.linkUrl
    this.disableImageScaling = $scope.disableImageScaling

    const defaultAvatar = new UriService(APP_IMAGE_URL).path('/img/avatars/' + MediaTypeService.getNameForType($scope.mediaType) + '.png').toString()

    this.imageUrl = defaultAvatar
    const element = angular.element(`<img src="${$scope.imageUrl}"/>`)[0]
    loaded(element, (error, preloaded) => {
      if (error) {
        throw error
      }
      if (element.naturalHeight >= 48 && element.naturalWidth >= 48) {
        this.imageUrl = $scope.imageUrl;
        $scope.$evalAsync();
      }
    })
  }
}



// WEBPACK FOOTER //
// ./source/components/source-avatar/source-avatar.js